var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27C11.4288 27 8.91543 26.2376 6.77759 24.8091C4.63975 23.3806 2.97351 21.3503 1.98957 18.9749C1.00563 16.5994 0.748183 13.9856 1.24979 11.4638C1.7514 8.94207 2.98953 6.62569 4.80761 4.80761C6.62569 2.98953 8.94207 1.7514 11.4638 1.24979C13.9856 0.748183 16.5994 1.00563 18.9749 1.98957C21.3503 2.97351 23.3806 4.63975 24.8091 6.77759C26.2376 8.91543 27 11.4288 27 14",
    stroke: "#B9B8C0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularLoader);
export default __webpack_public_path__ + "static/media/circular_loader.5b96e7c014c732c5b64326ad0ea31d2a.svg";
export { ForwardRef as ReactComponent };